export default "__VITE_PUBLIC_ASSET__8e700757__"